export const scrollToTop = () => {
  const bookingEngine = document.getElementById("bookingEnginePages");
  bookingEngine?.scrollIntoView({ block: "start", behavior: "smooth" });
};
